import React from "react";

import Input from "@mui/material/Input";
import Box from "@mui/material/Box";

const CreateAtribute = (props) => {
    const { previewData, setPreviewData } = props;
    const { attributes } = previewData;

    const handleAtribute = (event) => {
        const { id, name, value } = event.target;
        setPreviewData({
            ...previewData,
            attributes: attributes.map((item, index) => {
                if (index === +id) {
                    item[name] = value;
                    return item;
                } else return item;
            }),
        });
    };

    return attributes.map((item, index) => (
        <Box
            sx={{
                display: "flex",
                flexWrap: "nowrap",
                justifyContent: "space-between",
            }}
            key={index}
        >
            <Input
                id={index.toString()}
                name="trait_type"
                type="text"
                value={item.trait_type}
                inputComponent="input"
                variant="standard"
                placeholder="e.g. Size"
                onChange={handleAtribute}
                sx={{ flexBasis: "45%" }}
            />
            <Input
                id={index.toString()}
                name="value"
                type="text"
                value={item.value}
                inputComponent="input"
                variant="standard"
                placeholder="e.g. M"
                onChange={handleAtribute}
                sx={{ flexBasis: "45%" }}
            />
        </Box>
    ));
};

export default CreateAtribute;
